import { render, staticRenderFns } from "./benefits.vue?vue&type=template&id=93be0dfa&scoped=true"
import script from "./benefits?vue&type=script&lang=js&external"
export * from "./benefits?vue&type=script&lang=js&external"
import style0 from "./benefits.vue?vue&type=style&index=0&id=93be0dfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93be0dfa",
  null
  
)

export default component.exports